var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:(_vm.background),attrs:{"id":"threescene"}}),_c('div',{staticClass:"title-logo"},[_vm._v("\n    数知了仓储环境监测3D可视化系统\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }